import React from "react";
import PropTypes from "prop-types";
import { themeColor } from "../../constants";
import LoaderComponent from "components/Novus/LoaderComponent";

export function IBILoader({}) {
    return (
        <div className="flex-align-items w-100 h-100 flex-1">
            <LoaderComponent />
        </div>
    );
}

IBILoader.defaultProps = {
    visible: true,
    type: "ThreeDots",
    height: 100,
    width: 100,
    color: themeColor
};

IBILoader.propTypes = {
    visible: PropTypes.bool
};
